export default "__VITE_ASSET__e45441c1__"